import React from 'react';
import { Form, Radio } from 'antd';

const ChoiceGroup = ({ children, itemObj }) => {
  return !itemObj.isRadioGroup ? (
    <div className="recurrence-radio-group">{children}</div>
  ) : (
    <Form.Item wrapperCol={{ span: 24 }} shouldUpdate={true}>
      {() => {
        return (
          <Form.Item
            name={!itemObj || !itemObj.name ? ['rules', 'choice'] : itemObj.name}
            wrapperCol={{ span: 24, offset: !itemObj.offset ? 0 : itemObj.offset }}
            rules={[{ required: itemObj.isRadioGroup, message: 'Required' }]}
          >
            <Radio.Group onChange={($event) => itemObj.onChange($event.target.value)} className="recurrence-radio-group">
              {children}
            </Radio.Group>
          </Form.Item>
        );
      }}
    </Form.Item>
  );
};

export default ChoiceGroup;
